var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "imagecontainer" }, [
    _c("img", {
      staticClass: "photo",
      attrs: { src: _vm.src, alt: "Platzhalter für Foto" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }